import React from 'react';
import { Box } from '@apia/theme';
import { getVariant, makeStyledComponent, spacing } from '@apia/theme';
import { keyframes } from '@emotion/react';
import { Notification } from './Notification';
import { defaultNotifier } from './defaultNotifier';
import { useMount } from '@apia/util';

const vibrate = keyframes`
0% {
  transform: rotate(0);
}

25% {
  transform: rotate(1.5deg);
}

75% {
  transform: rotate(-1.5deg);
}

100% {
  transform: rotate(0);
}`;

const useSelector = defaultNotifier.useSelector;

const NotificationsList = makeStyledComponent(
  'NotificationsList',
  'layout.common.notifications.list',
  {
    '.notificationsFloatingList': {
      bottom: '10px',
      height: 'min-content',
      maxHeight: 'calc(100vh - 20px)',
      maxWidth: 'floatingNotifications',
      position: 'fixed',
      pr: '5px',
      right: '5px',
      width: '100%',
      zIndex: 'notifications',

      '& > *:not(:last-child)': {
        mb: spacing(5),
      },

      '.notification.animate': {
        animation: `${vibrate} 0.1s linear infinite`,
      },
    },

    '.fromRight-enter, .fromRight-appear': { transform: 'translateX(550px)' },
    '.fromRight-enter-active, .fromRight-appear-active': {
      transition: 'transform 150ms',
      transform: 'translateX(0)',
    },
    '.fromRight-exit': { transform: 'translateX(0)' },
    '.fromRight-exit-active': {
      transition: 'transform 150ms',
      transform: 'translateX(550px)',
    },
  },
  () => {
    const notifications = useSelector((current) => {
      return current;
    });

    useMount(() => {
      document.addEventListener('keydown', (ev) => {
        if (ev.code === 'Escape') {
          defaultNotifier.closeAll();
        }
      });
    });

    return (
      <Box
        className="notificationsFloatingList"
        {...getVariant('layout.common.components.notifications.list')}
      >
        {notifications.map((current) => {
          return <Notification notification={current} key={current.id} />;
        })}
      </Box>
    );
  },
);

export default React.memo(NotificationsList);
